import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalModule, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ImpersonateService } from 'app/profile/impersonate-user/impersonate.service';
import { ICredentials } from 'app/shared/models/credentials.model';
import { AuthService } from 'app/shared/services/auth.service';
import { HelperService } from 'app/shared/services/helper.service';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-user-login',
  standalone: true,
  imports: [MsalModule, RouterLink, TranslateModule],
  templateUrl: './user-login.component.html',
  styleUrl: './user-login.component.scss'
})
export class UserLoginComponent implements OnInit, OnDestroy {
  @Input() collapsedSidebar: boolean = true;
  private readonly _destroying$ = new Subject<void>();

  constructor(private router: Router,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: AuthService,
    private msalService: MsalService,
    private helperService: HelperService,
    public impersonateService: ImpersonateService
  ) {

  }

  navigateByUrl(url: string) {
    this.router.navigateByUrl(`/${url}`)
  }

  collapseSidebar() {
    this.helperService.collapsedSidebarEmiter.emit(true);
  }

  ngOnInit(): void { }

  get loginDisplay(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  get userName(): string {
    return this.credentials ? this.credentials.fullName ? this.credentials.fullName : `${this.credentials?.firstName} ${this.credentials?.lastName}` : '';
  }
  get userEmail(): string {
    return this.credentials ? `${this.credentials?.email}` : '';
  }


  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.msalService.instance.setActiveAccount(response.account);
        });
    } else {
      this.msalService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.msalService.instance.setActiveAccount(response.account);
        });
    }
  }

  logout(popup?: boolean) {
    this.authService.setCredentials();
    localStorage.clear();
    sessionStorage.clear();
    if (popup) {
      this.msalService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.msalService.logoutRedirect();
    }
  }

  exitImpersonateMode() {
    this.impersonateService.stopImpersonation();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  get credentials(): ICredentials | undefined {
    return this.authService.getCredentials();
  }
}
